import { render, staticRenderFns } from "./Grupuri-utilizatori_list.vue?vue&type=template&id=f0995daa&scoped=true&"
import script from "./Grupuri-utilizatori_list.vue?vue&type=script&lang=js&"
export * from "./Grupuri-utilizatori_list.vue?vue&type=script&lang=js&"
import style0 from "./Grupuri-utilizatori_list.vue?vue&type=style&index=0&id=f0995daa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0995daa",
  null
  
)

export default component.exports